import script from "./ActionDropdown.vue?vue&type=script&setup=true&lang=js"
export * from "./ActionDropdown.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/roland/vscode/yachtbroker/portal/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"ActionDropdown.vue"]])

export default __exports__